var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYellowArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5808 9.9283L2.5958 7.8983C2.8758 7.33246 2.8758 6.6733 2.5958 6.10746L1.5808 4.07163C0.711633 2.3333 2.58413 0.495798 4.30497 1.4058L5.2033 1.88413C5.33164 1.9483 5.4308 2.0533 5.4833 2.18163L8.80247 9.5608C8.93664 9.86413 8.81414 10.22 8.52247 10.3716L4.29913 12.5941C2.58413 13.5041 0.711633 11.6666 1.5808 9.9283Z",
    fill: "#F5AB38"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.51422 9.10001L7.33839 4.27002C7.09339 3.72752 7.67672 3.17918 8.20172 3.45918L11.5676 5.23252C12.9967 5.98502 12.9967 8.02668 11.5676 8.77918L10.3776 9.40335C10.0567 9.56668 9.66588 9.43251 9.51422 9.10001Z",
    fill: "#F5AB38"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowArrow);
export default __webpack_public_path__ + "static/media/yellow-Arrow.ae282e6aca6a14fa7443c5022e7f0f4c.svg";
export { ForwardRef as ReactComponent };